import { salesTransactionBeforeSave } from "services/sosInventoryService/salesTransaction/beforeSave";

import { OBJECT_TYPES } from "appConstants";

export function beforeSave(record) {
  const newRecord = salesTransactionBeforeSave(
    OBJECT_TYPES.SALES_RECEIPT.fullString,
    record
  );

  return newRecord;
}
